import Vue from 'vue';

import { ssoAllaSidorMixin } from 'v-mixins/ssoAllaSidorMixin';

import euiFormTextruta from 'v-components/euiFormTextruta.vue';
import euiFormKryssruta from 'v-components/euiFormKryssruta.vue';

import objectToFormData from 'object-to-formdata';

import euiDialogClasses from 'v-components/classes/euiDialogClasses';
import euiDialog from 'v-components/euiDialog';

import { ValidationObserver } from 'vee-validate';

import VeeValidateInstanceMedRattOptions from 'VeeValidateInstanceMedRattOptions';
VeeValidateInstanceMedRattOptions.runOnce();		// Kör funktionen om den inte redan körts!


window.ssoLoggaIn = window.ssoLoggaIn || {};	// För att undvika ESLint-varningar att den är odefinierad.

//##############################################################################################################################


//console.time('#TIMING: Skapa Vue-appen');	// Todo: TEMP!!!
const app = new Vue({
	el: '._vue-app-body-container',

	// Lokalt registrerade komponenter
	components: {
		euiFormTextruta,
		euiFormKryssruta,
		'validation-observer': ValidationObserver,
		euiDialog,
	},

	// Gemensam funktionalitet, utseende, data etc för alla sidor, se 'v-sso-Alla-sidor-mixin.js'.
	mixins: [ssoAllaSidorMixin],

	// Data utöver de från mixin ovan:
	data: {
		// Reaktiva data:

		// Obs! Måste stämma med form model som används i controllern (i detta fall på prov *utan* krav på C# naming convention, se [JsonProperty(...)]-attribut i C#!):
		loggaInFormModel: window.ssoLoggaIn.loggaInFormModel,

		aterstallLosenDialogConfig: new euiDialogClasses.dialogConfig([
			new euiDialogClasses.knappAvbryt(),
			new euiDialogClasses.knappEvent('Begär återställning/ändring', 'aterstallLosen', { validateBeforeEmit: true }),
		]),


		// Obs! Nedan: inte reaktiva (read-only) data, medelst användningen av Object.freeze():

		// –
	},

	methods: {

		onLoggaIn()
		{
			// Validera först!
			this.$refs.validationsobserveraren.validate()
				.then((isValid) => {

					if (!isValid) {
						// Om formuläret inte validerar:
						// Då har feltexter visats i formuläret:
						// Bara aborta emittandet.
					}
					else
					{
						// Allt validerar *client-side* (*standard-valideringar*):

						this.AjaxpostaOchHanteraResultat('/konto/logga-in', {
							formData: objectToFormData(this.loggaInFormModel),
							//doljSpinnerOnSuccess: false,
							onSuccessFunction: (resultat) => {

								// Stäng av redigeraläget:
								this.arIRedigeralage = false;

								// Navigera till returnUrl, eller till startsidan om sådan saknas:

								// I detta fall stoppar vi inte spinnern = den fortsätter tills navigeringen genomförts:
								//this.sidanInaktiveradMedFullOpacitetOchSpinnerVisasEfterXs = false;

								// CustomData = returnUrl (eller null/undefined):
								window.location.href = resultat.CustomData || '/';		// null coalescing operator i js: https://stackoverflow.com/a/476445/593779
							},
						});
					}
				});
		},

		onAterstallLosen()
		{
			this.aterstallLosenDialogConfig.visas = true;
		},

		onKnappTrycktIAterstallLosenDialog({ eventId, eventData }) {
			switch (eventId) {
				case 'aterstallLosen':
					{
						// När man kommer hit: Allt validerar *client-side* (*standard-valideringar*):

						this.AjaxpostaOchHanteraResultat('/konto/begar-aterstallning-losen', {
							formData: objectToFormData({ epost: this.loggaInFormModel.epost }),
							doljSpinnerOnSuccess: true,
							onSuccessFunction: (resultat) => {

								// Visa lyckatmeddelande:
								this.visaMeddelande(
									`
<p>Vi har nu skickat ett återställnings&shy;mejl till <b>${this.loggaInFormModel.epost}</b>.</p>
<p>Följ anvisningarna i mejlet för att återställa/ändra ditt lösen.</p>
									`,
									{ ikon: 'lyckatmeddelande', ikonCssModifierClass: '-lyckat' }
								);

								// Först nu ska dialogen stängas!
								this.aterstallLosenDialogConfig.visas = false;
							},
						});

						break;
					}
			}
		},
	},


	//== Lifecycle hooks  ================================================================================================================

	//created()
	//{
	//	// Called synchronously after the instance is created. At this stage, the instance has finished processing the options which means the following have been set up: data observation, computed properties, methods, watch/event callbacks. However, the mounting phase has not been started, and the $el property will not be available yet.
	//},

	//mounted()
	//{
	//	// Programmatisk bind:
	//	this.$on('meddelandedialog-stangs', this.onMeddelandedialogStangs);
	//},

});
//console.timeEnd('#TIMING: Skapa Vue-appen');	// Todo: TEMP!!!


export default app;

// Sätter även en global variabel, för enkel åtkomst till Vue-instansen (motsvarande $root) från DevTools console, icke-modulariserad javascript etc:
window.App = app;
